import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "./api";

const STAGES = [
  "Raw Lead",
  "Active Lead",
  "Discovery Booked",
  "Discovery Completed",
  "Client Closed",
];

const STAGE_ACCENT = {
  "Raw Lead": "from-slate-500/30 to-slate-800/10",
  "Active Lead": "from-violet-500/30 to-violet-800/10",
  "Discovery Booked": "from-blue-500/30 to-blue-800/10",
  "Discovery Completed": "from-amber-400/30 to-amber-700/10",
  "Client Closed": "from-emerald-500/30 to-emerald-800/10",
};

export default function Pipeline() {
  const [board, setBoard] = useState(null);

  useEffect(() => {
    api.get("/crm/pipeline").then((r) => setBoard(r.data));
  }, []);

  if (!board) {
    return (
      <div className="text-white/60 text-sm" data-testid="pipeline-loading">
        Loading pipeline…
      </div>
    );
  }

  return (
    <div data-testid="pipeline-page">
      <header className="mb-6">
        <div className="text-xs tracking-[0.3em] uppercase text-amber-300/80">
          Kanban
        </div>
        <h1 className="text-3xl font-light mt-1">Pipeline</h1>
      </header>

      <div className="grid grid-cols-5 gap-4 min-h-[70vh]">
        {STAGES.map((s) => {
          const cards = board[s] || [];
          return (
            <div
              key={s}
              className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-3 flex flex-col overflow-hidden"
              data-testid={`col-${s.replace(/\s/g, "-").toLowerCase()}`}
            >
              <div className="flex items-center justify-between px-2 pb-2 mb-2 border-b border-white/[0.05]">
                <div className="flex items-center gap-2">
                  <div
                    className={`w-2 h-2 rounded-full bg-gradient-to-br ${STAGE_ACCENT[s]}`}
                  />
                  <span className="text-xs uppercase tracking-widest text-white/70">
                    {s}
                  </span>
                </div>
                <span className="text-xs text-white/40 tabular-nums">
                  {cards.length}
                </span>
              </div>
              <div className="space-y-2 overflow-y-auto max-h-[75vh] pr-1">
                {cards.slice(0, 100).map((c) => (
                  <Link
                    key={c.id}
                    to={`/crm/contacts/${c.contact_id}`}
                    className="block rounded-xl border border-white/[0.06] bg-white/[0.03] hover:bg-white/[0.06] p-3 transition"
                    data-testid={`card-${c.contact_id}`}
                  >
                    <div className="text-sm truncate">{c.name}</div>
                    <div className="text-xs text-white/50 truncate mt-0.5">
                      {c.demographic || c.status || "—"}
                    </div>
                    {c.email && (
                      <div className="text-[11px] text-white/40 truncate mt-1">
                        {c.email}
                      </div>
                    )}
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-[10px] text-white/40 truncate">
                        {c.lead_source}
                      </span>
                      {c.deal_size ? (
                        <span className="text-[11px] text-amber-200/80 tabular-nums">
                          ${Math.round(c.deal_size)}
                        </span>
                      ) : null}
                    </div>
                  </Link>
                ))}
                {cards.length > 100 && (
                  <div className="text-xs text-white/40 text-center py-2">
                    …{cards.length - 100} more
                  </div>
                )}
                {cards.length === 0 && (
                  <div className="text-xs text-white/30 text-center py-6">
                    No leads
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
